import { ISignInData, ISignInDataKeys } from "./hooks/useSignIn";
import ConfirmNumberPhone, {
  IConfirmNumberPhoneData,
} from "../../../../shared/forms/confirmNumberPhoneForm";
import { transformPhone } from "../../../../../lib/utils";
import Button from "../../../../ui/button";
import useAuthUserSingIn from "../../../../../api/hooks/hooks-auth/use-auth-user-signIn";
import { useEffect } from "react";

interface IUserFormProps {
  onChange: (key: ISignInDataKeys, data: string) => void;
  data: ISignInData;
  onSendData: () => void;
  isDisable: boolean;
}

const SignInForm = ({
  data,
  isDisable,
  onChange,
  onSendData,
}: IUserFormProps) => {
  const {
    data: authUserSignInData,
    error: authUserSignInError,
    isMutating: authUserSignInIsMutating,
    trigger: authUserSignInTrigger,
  } = useAuthUserSingIn();

  useEffect(() => {
    if (authUserSignInData?.code) {
      onChange("otp", authUserSignInData.code);
    }
  }, [authUserSignInData?.code]);

  const onClickConfirmPhone = async () => {
    if (data.numberPhone) {
      await authUserSignInTrigger({
        phone: transformPhone(data.numberPhone),
      });
    }
  };

  return (
    <ConfirmNumberPhone
      title="Заполните форму ниже чтобы войти:"
      data={
        {
          numberPhone: data.numberPhone,
          otp: data.otp,
        } as IConfirmNumberPhoneData
      }
      otp={authUserSignInData?.code}
      onChange={onChange}
      onActions={onClickConfirmPhone}
    >
      <div>
        <Button label="Войти" onClick={onSendData} disabled={isDisable} />
      </div>
    </ConfirmNumberPhone>
  );
};

export default SignInForm;
